import { connect } from "react-redux";
import { getListChiDelete } from "actions/DanhSachChiDelete";
import { DanhSachChiBiXoa } from "components/ThongKe/DanhSachChiBiXoa";

const mapStateToProps = (state) => ({
  DanhSachChiBiXoa: state.DanhSachChiBiXoa,
  user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
  getListChiDelete: (dataSearch) => dispatch(getListChiDelete(dataSearch)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DanhSachChiBiXoa);
